export const searchColumnArray = function(data,search){
  search.forEach(element => {
    if(element.text!=""){
      if(element.type==undefined || element.type=="string"){
        data=this.$searchArray(data,element.text,element.column);
      }else if(element.type=="smallDate"){
        var date="";
        element.text.split(".").forEach((d,di) => {
          date=d+(di>0?"-":'')+date;
        });
        data=this.$searchArray(data,date,element.column);
      }else if(element.type=="date"){
        element.text.split(" ")[0].split(".").forEach((d,di) => {
          date=d+(di>0?"-":'')+date;
        });
        if(element.text.split(" ").length>1){
          date=date+"T";
          element.text.split(" ")[1].split(":").forEach((d,di) => {
            date=date+d+(di==0?":":'');
          });
        }
        element.isDate="DD.MM.YYYY HH:MM";
        data=this.$searchArray(data,date,element.column);
      }
    }
  });
  return data;
}